import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";
import { buildQueryParams } from "../../utils/commonMethods";

const manageUsersAdapter = createEntityAdapter({
  selectId: (user) => user.id,
});
const rolesAdapter = createEntityAdapter({
  selectId: (role) => role.id,
});

const usersInitialState = manageUsersAdapter.getInitialState();
const rolesInitialState = rolesAdapter.getInitialState();

export const manageUsersSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ email, name, query, orderBy, orderByType, page, pageSize }) => {
        const params = {
          Email: email,
          Name: name,
          Query: query,
          OrderBy: orderBy,
          OrderByType: orderByType,
          Page: page,
          PageSize: pageSize,
        };

        const queryString = buildQueryParams(params);

        return `/users?${queryString}`;
      },
      transformResponse: (responseData) => {
        const loadedUsers = responseData.items.map((d) => {
          const { id, firstName, lastName, email, roles, password } = d;
          return {
            id,
            firstName,
            lastName,
            name: `${firstName} ${lastName}`,
            email,
            roles,
            password,
            pageSettings: {
              totalRecordsCount: responseData.total,
              page: responseData.page,
              pageSize: responseData.pageSize,
            },
          };
        });
        return manageUsersAdapter.setAll(usersInitialState, loadedUsers);
      },
      providesTags: (result, error, arg) => {
        if (error) {
          return [{ type: "Users", id: "ERROR" }];
        }
        return [
          { type: "Users", id: "LIST" },
          ...(result?.ids || []).map((id) => ({ type: "Users", id })),
        ];
      },
    }),
    getRoles: builder.query({
      query: () => `/roles`,
      transformResponse: (responseData) => {
        const loadedRoles = responseData;
        return rolesAdapter.setAll(rolesInitialState, loadedRoles);
      },
      providesTags: (result, error, arg) => {
        if (error) {
          return [{ type: "Roles", id: "ERROR" }];
        }
        return [
          { type: "Roles", id: "LIST" },
          ...(result?.ids || []).map((id) => ({ type: "Roles", id })),
        ];
      },
    }),

    getHierarchy: builder.query({
      query: () => `/hierarchy`,
    }),

    createUser: builder.mutation({
      query: (data) => ({
        url: `/users`,
        method: "POST",
        body: {
          ...data,
        },
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),

    updateUser: builder.mutation({
      query: ({ data, id }) => ({
        url: `/users/${id}`,
        method: "PUT",
        body: {
          ...data,
        },
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),

    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/users/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
  }),
});
export const {
  useGetUsersQuery,
  useGetRolesQuery,
  useGetHierarchyQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = manageUsersSlice;
